import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { ToDateTimeText, ToDateFullMonthText } from "../../utils/date";
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
//Component
import { Modal } from "../../stories/modal";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
import * as alertDialog from "../../utils/alert";
//Function

import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { TextField, Divider } from "@material-ui/core";
import * as api from "./api";
import * as common from "../../utils/common-function";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { API_URL } from "../../utils/api-utils";
import BootstrapTable from 'react-bootstrap-table-next';

const useStyles = makeStyles((theme) => ({

    textLabel: {
        color: '#000'
    },

}));


function ModalAddEditQuota(props) {
    const classes = useStyles();
    const { open } = props;
    const { userID, ...otherprops } = props;

    const method = useForm();
    const { register, getValues } = method;
    const { setValue, setError, clearErrors, errors, control } = method;
    const [DataInfo, setDataInfo] = useState([]);
    const [initModal, setInitModal] = useState(0);
    const [quotaLimit, setQuotaLimit] = useState(0);
    const [checkActive, setCheckActive] = useState(false);

    useEffect(() => {
        if (!open) return;
        if (typeof userID === "undefined") {
            setQuotaLimit(0);
            return;
        }
        else {
            fetch(userID);
        }
    }, [userID, setValue, open]);

    const fetch = async (pUserID) => {
        let param = { USERNAME: pUserID };
        let res = await api.GetJobScheduleQuotaInfo(param);
        setDataInfo(res);
        setQuotaLimit(res?.QUOTA_LIMIT);
        setCheckActive(res?.ISACTIVE === 1 ? true : false);
    };
    const handleChangeStatus = (event) => {
        setCheckActive(event.target.checked);
        setInitModal(1);
        setQuotaLimit(getValues().Quota);
    }

    const saveQuota = async () => {
        // console.log(getValues().UserName);
        // console.log(getValues().Quota);
        let param = { USERNAME: getValues().UserName, QUOTA: getValues().Quota, STATUS: checkActive };
        if (getValues().UserName === '') {
            alertDialog.ErrorDialog("Please Input UserName");
            return;
        }
        if (typeof userID === "undefined") {
            let res = await api.CheckDuplicateQuata(param);
            if (res.ResultCode === 20) {
                alertDialog.ErrorDialog(res?.Message);
                return;
            }
        }
        let resSave = await api.SaveJobScheduleQuota(param);
        if (resSave.ResultCode === 10) { //Success
            alertDialog.SuccessShowButtonCloseModal("Add/Edit Quota completed.", props);
            return;
        }

        if (resSave.ResultCode === 20) {
            alertDialog.ErrorDialog(resSave?.Message);
            return;
        }



    }
    return (
        <Modal {...otherprops} SaveText="Submit" onSave={saveQuota} title={typeof userID !== "undefined" ? "Edit Quota" : "Add Quota"}>

            <Box m={3} maxWidth="500px" flexGrow={1}>
                <TextField
                    id="UserName-textarea"
                    name="UserName"
                    inputRef={register}
                    label="UserName "
                    placeholder=""
                    //onChange={ClearError}
                    variant={typeof userID !== "undefined" ? "filled" : "outlined"}
                    rows={1}
                    fullWidth
                    InputProps={{
                        readOnly: (typeof userID !== "undefined" ? true : false),
                    }}
                    defaultValue={typeof userID !== undefined ? userID : ""}
                    error={errors?.hasOwnProperty("UserName")}
                    helperText={errors?.["UserName"]?.message || ''}
                />
            </Box>
            <Box m={3} maxWidth="500px" flexGrow={1}>
                {/* <input type="text" value={quotaLimit} onChange={(e) => setQuotaLimit(e.target.value)} /> */}
                <TextField
                    id="quota-textarea"
                    name="Quota"
                    inputRef={register}
                    label="Quota "
                    placeholder=""
                    variant="outlined"
                    //type="number"
                    onChange={(e) => setQuotaLimit(e.target.value)}
                    rows={1}
                    fullWidth
                    value={quotaLimit}
                />
            </Box>
            <Box m={3} maxWidth="500px" flexGrow={1}>
                <FormControl variant="outlined" className={classes.textInput}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checkActive}
                                onChange={handleChangeStatus}
                                name="checkActive"
                                color="primary"
                            // value={DataInfo?.ISACTIVE === 0 ? false : true}
                            />
                        }
                        label="Active"
                    />
                </FormControl>
            </Box>


        </Modal>
    );
}
export default ModalAddEditQuota;
